import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ModalController, PopoverController} from '@ionic/angular';
import {AccountPaymentFavoriteService} from '@wlp/ui-bs-account-payment-favorite';
import {BilletInterestTypeEnum, BilletLotService, BilletService} from '@wlp/ui-bs-cashin';
import {UserInfoService} from '@wlp/ui-bs-login';
import {FeesDto} from '@wlp/ui-px-cashin';
import * as moment from 'moment';
import {LoadingService} from 'src/app/core/layout/services/loading.service';

@Component({
  selector: 'ui-t-form-fees',
  templateUrl: './form-fees.html',
  styleUrls: ['./form-fees.scss'],
})
export class FormFees implements OnInit {

  @Input() public fees: FeesDto;
  @Input() public billetDueTime: Date;
  @Output() public submitForm = new EventEmitter<string>();
  @Output() public onCancel = new EventEmitter<string>();
  public enableFees = false;
  public interestForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public modalController: ModalController,
    public popoverController: PopoverController,
    public router: Router,
    protected userInfoService: UserInfoService,
    public billetService: BilletService,
    public billetLotService: BilletLotService,
    public accountPaymentFavoriteService: AccountPaymentFavoriteService,
    private cd: ChangeDetectorRef,
    private loadingService: LoadingService,
  ) {
    moment.locale('pt-br');
  }

  public ngOnInit() {
    this.createInterestForm();
    if (this.fees && this.fees.type) {
      this.enableFees = true;
    }
  }

  public getFees() {
    const feesInputToEnum = (value: string): BilletInterestTypeEnum => {
      switch (value) {
        case 'DAYS_INTEREST':
          return BilletInterestTypeEnum.DAYS_INTEREST;
        case 'PROPORTIONAL_INTEREST':
          return BilletInterestTypeEnum.PROPORTIONAL_INTEREST;
      }
      return null;
    };

    const feesType = this.interestForm.controls.interestType.value;
    const feesValue = this.interestForm.controls.interestAmount.value;
    const selectedFees = feesInputToEnum(this.enableFees ? feesType : null);
    const feesExpirationDate = (this.interestForm.controls.interestDays.value).trim().split('/').reverse().join('-');

    return {
      type: selectedFees,
      value: feesValue,
      expirationDate: feesExpirationDate,
    };
  }

  public createInterestForm() {
    let interestDays = "";
    let feesValueFormater = this.fees.value

    if(this.fees){
      interestDays = this.calculateInterestDeadline(this.fees.days)
    }

    if (this.fees.type === 'PROPORTIONAL_INTEREST') {
      feesValueFormater = parseFloat(this.fees.value).toFixed(1)
    } else if (this.fees.type === 'DAYS_INTEREST') {
      feesValueFormater = parseFloat(this.fees.value).toFixed(2)
    }

    this.interestForm = this.formBuilder.group({
      interestType: new FormControl(this.fees ? this.fees.type : ''),
      interestAmount: new FormControl(this.fees ? feesValueFormater : ''),
      interestDays: new FormControl(this.fees ? interestDays : ''),
    });
    this.loadingService.hide();
  }

  public clearFeesAmount() {
    this.interestForm.controls.interestAmount.clearValidators()
    this.interestForm.controls.interestAmount.setValue('')
  }

  public handleClickSaveButton() {
    this.submitForm.emit();
  }

  public cancel() {
    this.onCancel.emit();
  }

  public calculateInterestDeadline(billetInterestDays: string) {
    const billetInterestDaysNumber = parseInt(billetInterestDays);
    const billetDueTimeMoment = moment(this.billetDueTime, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
    const billetInterestDeadline = billetDueTimeMoment.add(billetInterestDaysNumber, 'days');
    const formattedDeadline = billetInterestDeadline.format('DD/MM/YYYY');
    return formattedDeadline;
  }
}
